export default "__VITE_ASSET__GHQ_$G1W__"